<template>
  <div class="d-flex align-items-center" style="min-height: 100vh; background-color: #fdfdfd;">
    <div class="col-sm-8 col-md-6 col-lg-4 mx-auto" style="min-width: 300px;">
      <div class="text-center mt-5 mb-5">
        <h3 class="font-weight-bold" style="color: var(--primary-color);">TransitionCRM</h3>
      </div>

      <b-card class="shadow" style="border: none;">
        <h5 class="text-center mb-1 font-weight-bold">Forgot Password</h5>
        <p class="text-center text-muted mb-4">Enter your email to receive a reset link</p>

        <b-alert variant="success" :show="success" class="text-center">
          <i class="material-icons mr-1" style="font-size: 18px; vertical-align: middle;">check_circle</i>
          If an account exists with that email, a password reset link has been sent. Please check your inbox.
        </b-alert>

        <b-form @submit.prevent="onSubmit">
          <b-form-group label="Email" label-class="form-label">
            <b-form-input
              v-model="email"
              type="email"
              placeholder="Enter your email address"
              required
              :disabled="isLoading || success"
            />
          </b-form-group>

          <div v-if="error" class="alert alert-danger mt-3" role="alert">
            Cannot reset password for the given email. Please try again.
          </div>

          <div class="form-group">
            <b-button type="submit" variant="primary" block :disabled="isLoading || success" style="height: 2.3rem;">
              <span v-if="isLoading">
                <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                Sending...
              </span>
              <span v-else>Reset Password</span>
            </b-button>
          </div>

          <div class="text-center">
            Remember your password?
            <router-link :to="{ name: 'login' }" style="text-decoration: underline;">Login</router-link>
          </div>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ForgotPass',
  data() {
    return {
      email: '',
      success: false,
      error: false,
      isLoading: false,
    };
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    async onSubmit() {
      this.error = false;
      this.isLoading = true;

      try {
        await this.resetPassword({ email: this.email });
        this.success = true;
      } catch (_e) {
        this.error = true;
      }

      this.isLoading = false;
    },
  },
};
</script>
